// @flow

import axios from 'axios'

import { getApi } from './api.core'
const { v4: uuidv4 } = require('uuid')

const GET_LANGUAGES_URL =
  'https://dev.microsofttranslator.com/languages?api-version=2.0&scope=translation'
const TRANSLATE_URL = 'https://api.cognitive.microsofttranslator.com'

const SUBSCRIPTION_KEY = '7d814cbb81f746beb6483e0c918d780d'

export const getTranslation = () => getApi('api/translate/')

export const translateText = ({ from, to, text }) =>
  axios({
    baseURL: TRANSLATE_URL,
    url: '/translate',
    method: 'post',
    headers: {
      'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY,
      'Content-type': 'application/json',
      'X-ClientTraceId': uuidv4().toString(),
    },
    params: {
      from,
      to,
      text,
      'api-version': '3.0',
    },
    data: [
      {
        text,
      },
    ],
    responseType: 'json',
  })

export const getLanguages = ({ locale }) =>
  axios.get(GET_LANGUAGES_URL, { headers: { 'accept-language': locale } })
